import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { AuthService } from '../../services/AuthService/auth';
import { CountryBlockchainMappingResponse } from '../../models/country-config.dto';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';
import { EmptyState } from '../../shared/components/empty-state/empty-state';
import { UpsertCountryMappingDialog } from '../../dialogs/upsert-country-mapping-dialog/upsert-country-mapping-dialog';

@Component({
  selector: 'app-country-mappings',
  imports: [CommonModule, MatButtonModule, MatIconModule, ErrorBanner, EmptyState],
  templateUrl: './country-mappings.html',
  styleUrl: './country-mappings.scss',
})
export class CountryMappings implements OnInit {
  mappings = signal<CountryBlockchainMappingResponse[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  constructor(private admin: AdminService, private auth: AuthService, private dialog: MatDialog) {}

  get canEdit(): boolean {
    return this.auth.getSession()?.role === 'SUPERADMIN';
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.admin.listCountryMappings().subscribe({
      next: (res) => {
        this.isLoading.set(false);
        this.mappings.set(res.data);
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to load country mappings.'));
      },
    });
  }

  openUpsertDialog(): void {
    this.dialog
      .open(UpsertCountryMappingDialog, { width: '420px' })
      .afterClosed()
      .subscribe((saved) => {
        if (saved) {
          this.load();
        }
      });
  }
}
